import { render, staticRenderFns } from "./legal-urge-action-area.vue?vue&type=template&id=24d32e05"
import script from "./legal-urge-action-area.vue?vue&type=script&lang=ts"
export * from "./legal-urge-action-area.vue?vue&type=script&lang=ts"
import style0 from "./legal-urge-action-area.vue?vue&type=style&index=0&id=24d32e05&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports